<template>
    <div class="cardContainer">
        <van-row>
            <van-col span="24" class="dayRow">
                <van-row style="width: 100%;" justify="center" >
                    <van-col span="4" v-for="(i, index) in dayList" :key="index">
                        <div class="dayCard">
                            <div class="dayImage">
                                <img src="@/assets/themeThree/Day_BG.png" alt="">
                                <span class="day-num">{{ index + 1 }}</span>
                            </div>
                            <div class="dateText"
                                :style="{ color: index == 0 && showClickButton ? '#36d836' : index == 0 && !showClickButton ? 'gray' : '' }">
                                {{ dayFormat(i.date, 0) }}</div>
                            <div class="dateText"
                                :style="{ color: index == 0 && showClickButton ? '#36d836' : index == 0 && !showClickButton ? 'gray' : '' }">
                                {{ formatCurrency(i.amount) }}
                            </div>
                        </div>
                    </van-col>
                </van-row>
            </van-col>
            <van-col span="24" class="availbleContent">
                <div class="availableTitle">{{ $t('activity.available') }}</div>
                <div class="availableTitle">{{ 'R$ ' + formatCurrency(availableValue) }}</div>
                <div class="click_btn" v-if="props.showClickButton" @click="clickOnButton">{{
                    $t('activity.click') }}</div>
                <div class="givenValueText">{{ $t('activity.given') }} {{ formatCurrency(givenValue) }}</div>
            </van-col>
        </van-row>
    </div>

</template>
<script lang="ts" setup>
import { dayFormat, formatCurrency, getDefaultRewards } from '@/utils/commonFunction';
import { PropType } from 'vue';

const props = defineProps({
    showClickButton: {
        type: Boolean,
    },
    availableValue: {
        type: Number,
        default: () => 0
    },
    givenValue: {
        type: Number,
        default: () => 0
    },
    dayList: {
        type: Array as PropType<(any)[]>,
        default: () => getDefaultRewards()
    },
    createDate: {
        type: String,
        default: () => ""
    },
})
const emits = defineEmits(['getClaim'])

const clickOnButton = () => {
    emits('getClaim')
}

</script>
<style scoped>
.cardContainer {
    background: #0F1527;
    border-radius: 10px;
    padding: 10px 10px;
    color: #fff;
    font-size: 12px;
    margin: 10px 15px 0;
}

.dayRow {
    display: flex;
    flex-direction: row;
}

.dayColumn {
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    align-items: center;
    border-right: 3px dashed #80808070;
}

.availbleContent {
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    align-items: center;
    padding: 20px 10px 0px;
}

.availableTitle {
    color: #35a5f8;
    font-size: 13px;
    padding-bottom: 5px;
}

.day-num {
    position: absolute;
    font-size: 18px;
    white-space: nowrap;
    color: #FFF5D7;
    text-shadow: -1px -1px 0 #300000, 1px -1px 0 #300000, -1px 1px 0 #300000, 1px 1px 0 #300000;
    z-index: 800;
    font-weight: 700;
    left: 55%;
    top: 25%;
}

.dateText {
    padding-top: 5px;
}

.dayImage img {
    width: 85%;
}

.dayImage {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    margin-bottom: 5px;
}

.centerAlignment {
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    align-items: center;
}

.dayCard {
    color: #fff;
    font-size: 9.5px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    min-width: 13%;
    flex-shrink: 0;
    padding-top: 5px;
}

.dayCardWrapper {
    display: flex;
    overflow-x: auto;
    white-space: nowrap;
    scrollbar-width: none;
    -ms-overflow-style: none;
    flex: 1;
}

.dayCardWrapper::-webkit-scrollbar {
    display: none;
}

.scrollRow {
    display: flex;
    align-items: center;
    width: 100%;
    position: relative;
    gap: 5px;
}

.arrowLeft img {
    width: 10px;
}

.arrowRight {
    position: absolute;
    right: 0px;
}

.arrowLeft {
    position: absolute;
    left: 0px;
}

.arrowRight img {
    width: 10px;
    transform: rotate(180deg);
}

.dayTitle {
    font-weight: bold;
    padding-bottom: 5px;
}

.rightBorder {
    border-right: 1px solid #80808070;
}

.click_btn {
    color: #fff;
    font-size: 11.5px;
    background-image: linear-gradient(180deg, #35A5F8 0%, #0268CB 100%);
    border-radius: 5px;
    padding: 10px;
    display: flex;
    align-items: center;
    display: flex;
    text-align: center;
    justify-content: center;
    width: 40%;
    margin-top: 10px;
}

.givenValueText {
    font-size: 10px;
    font-style: italic;
    color: #fff;
    padding-top: 5px;
}

.valueText {
    padding: 2px 0 5px;
}
</style>